import { render, staticRenderFns } from "./Anexos.vue?vue&type=template&id=0b990cca&scoped=true&"
import script from "./Anexos.vue?vue&type=script&lang=js&"
export * from "./Anexos.vue?vue&type=script&lang=js&"
import style0 from "./Anexos.vue?vue&type=style&index=0&id=0b990cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b990cca",
  null
  
)

export default component.exports